module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "calibre3",
    attrs: {
      "cellpadding": "1",
      "cellspacing": "3",
      "summary": "Mike: Table of Contents"
    }
  }, [_c('tbody', {
    staticClass: "calibre4"
  }, [_c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "calibre6"
  }), _c('td', {
    staticClass: "calibre6"
  }, [_c('h2', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "calibre6"
  }), _c('td', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0005#ch1"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0006#ch2"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE JOURNEY DOWN")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0007#ch3"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE FINDS A FRIENDLY NATIVE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0008#ch4"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T THE NETS")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0009#ch5"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVELRY BY NIGHT")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0011#ch6"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N WHICH A TIGHT CORNER IS EVADED")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0012#ch7"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N WHICH MIKE IS DISCUSSED")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0013#ch8"
    }
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROW WITH THE TOWN")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0015#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE THE STORM")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0016#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE GREAT PICNIC")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0017#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE CONCLUSION OF THE PICNIC")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0018#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE GETS HIS CHANCE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0019#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE M.C.C. MATCH")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0020#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SLIGHT IMBROGLIO")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0021#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE CREATES A VACANCY")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0022#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N EXPERT EXAMINATION")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0023#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOTHER VACANCY")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0024#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB HAS NEWS TO IMPART")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0025#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE GOES TO SLEEP AGAIN")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0027#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE TEAM IS FILLED UP")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0028#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARJORY THE FRANK")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0029#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YATT IS REMINDED OF AN ENGAGEMENT")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0030#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SURPRISE FOR MR. APPLEBY")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0031#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUGHT")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0032#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCHING ORDERS")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0034#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE AFTERMATH")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0035#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE RIPTON MATCH")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0036#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE WINS HOME")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0038#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YATT AGAIN")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0039#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R. JACKSON MAKES UP HIS MIND")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0040#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDLEIGH")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0041#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SMITH")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0042#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAKING OUT A CLAIM")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0044#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UERILLA WARFARE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0045#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NPLEASANTNESS IN THE SMALL HOURS")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0046#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAIR")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0047#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE FINDS OCCUPATION")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0048#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE FIRE BRIGADE MEETING")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XXXIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0050#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHILLES LEAVES HIS TENT")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XL.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0051#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE MATCH WITH DOWNING’S")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0052#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE SINGULAR BEHAVIOUR OF JELLICOE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0053#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLICOE GOES ON THE SICK-LIST")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0054#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE RECEIVES A COMMISSION")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0056#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND FULFILS IT")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0057#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URSUIT")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0058#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DECORATION OF SAMMY")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0059#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R. DOWNING ON THE SCENT")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0060#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE SLEUTH-HOUND")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("XLIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0061#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHECK")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("L.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0063#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DESTROYER OF EVIDENCE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0064#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINLY ABOUT BOOTS")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0065#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE TRAIL AGAIN")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0066#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE KETTLE METHOD")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0067#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAIR HAS A WORD WITH MIKE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0068#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEARING THE AIR")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0070#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N WHICH PEACE IS DECLARED")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0071#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R. DOWNING MOVES")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0072#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ARTIST CLAIMS HIS WORK")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("LIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section0073#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDLEIGH "), _c('i', {
    staticClass: "calibre8"
  }, [_vm._v("v.")]), _vm._v(" WRYKYN")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "calibre6"
  }), _c('td', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre5"
  }, [_c('td', {
    staticClass: "calibre6"
  }), _c('td', {
    staticClass: "calibre6"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76744d64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0003.vue
// module id = 63
// module chunks = 0